// @core/api/endpoints/platform/update_platform.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformResponse,
  UpdatePlatformRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update platform
 * Updates an existing platform's information and configuration. Requires admin privileges on the platform.
 */
export async function UpdatePlatform(
  platform_id: string,
  data: UpdatePlatformRequest,
  options?: RequestOptions
): Promise<PlatformResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.put<PlatformResponse>(requestPath, data, requestOptions);
}
